<script>
import NonDynamicTransportNotificationRow from './NonDynamicTransportNotificationRow';

export default {
  name: 'NonDynamicTransportNotifications',
  components: {
    NonDynamicTransportNotificationRow,
  },
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localNotifications: [],
      notificationMenu: false,
    };
  },
  methods: {
    addNotification() {
      const notifications = [...this.localNotifications];
      notifications.push(null);
      this.localNotifications = notifications;
    },
    removeNotification(index) {
      const notifications = [...this.localNotifications];
      notifications.splice(index, 1);
      this.localNotifications = notifications;
      this.$forceUpdate();
    },
    setLocalNotification(item) {
      const notifications = [...this.localNotifications];
      notifications[item.index] = item.value;
      this.localNotifications = notifications;
    },
    setNotifications() {
      this.$emit('save', this.localNotifications);
      this.notificationMenu = false;
    },
  },
  created() {
    if (!this.notifications.length) {
      this.addNotification();
    } else {
      this.localNotifications = [...this.notifications];
    }
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="notificationMenu"
      persistent
      width="400"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          fab
          small
          color="primary"
        >
          <v-icon dark>announcement</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ $t('nonDynamicTransport.labels.notifications') }}
        </v-card-title>

        <v-layout column>
          <non-dynamic-transport-notification-row
            v-for="(notification, index) in localNotifications"
            :key="`notification-${index}`"
            :notification="notification"
            :index="index"
            :read-only="readOnly"
            @remove="removeNotification"
            @input="setLocalNotification"
          />
        </v-layout>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex>
            <v-btn
              color="primary"
              :disabled="readOnly"
              @click="addNotification"
            >
              {{ $t('buttons.addRow') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn
              color="success"
              @click="setNotifications"
            >
              <div v-if="!readOnly">{{ $t('buttons.save') }}</div>
              <div v-else> Close </div>
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportNotifications.vue